const SELECTED_SIGNUP_ROLE_KEY = "selectedSignupRole";
const SIGNUP_VERIFIED_KEY = "signupVerified";

export const saveSelectedSignupRole = (role) => {
  try {
    if (role) {
      sessionStorage.setItem(SELECTED_SIGNUP_ROLE_KEY, role);
    } else {
      sessionStorage.removeItem(SELECTED_SIGNUP_ROLE_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

export const getSelectedSignupRole = () => {
  try {
    return sessionStorage.getItem(SELECTED_SIGNUP_ROLE_KEY);
  } catch {
    return null;
  }
};

export const clearSelectedSignupRole = () => {
  try {
    sessionStorage.removeItem(SELECTED_SIGNUP_ROLE_KEY);
  } catch {
    // ignore storage errors
  }
};

export const hasSignupRoleSelected = (role) => {
  const selectedRole = getSelectedSignupRole();
  if (!selectedRole) return false;
  if (role && selectedRole !== role) return false;
  return true;
};

export const markSignupVerified = () => {
  try {
    sessionStorage.setItem(SIGNUP_VERIFIED_KEY, "1");
  } catch {
    // ignore storage errors
  }
};

export const clearSignupVerified = () => {
  try {
    sessionStorage.removeItem(SIGNUP_VERIFIED_KEY);
  } catch {
    // ignore storage errors
  }
};

export const isSignupVerified = () => {
  try {
    return sessionStorage.getItem(SIGNUP_VERIFIED_KEY) === "1";
  } catch {
    return false;
  }
};
